module.exports = __webpack_public_path__ + "img/Hardware_HL.7df7946d.jpg";